import { API } from "@/lib/api";

// Streams a plain-text AI response token-by-token via fetch (axios can't stream in the browser).
// Cookies carry the session (staff access_token or patient portal_token); we only add the
// X-Facility-Id header for staff endpoints, matching the axios request interceptor.
export async function streamAI(path, { method = "POST", body, facilityId, portal = false, onChunk, signal } = {}) {
  const headers = {};
  if (body) headers["Content-Type"] = "application/json";
  if (!portal) {
    const fid = facilityId || (typeof localStorage !== "undefined" && localStorage.getItem("span_active_facility"));
    if (fid) headers["X-Facility-Id"] = fid;
  }
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 90000);
  if (signal) signal.addEventListener("abort", () => controller.abort());
  try {
    const res = await fetch(`${API}${path}`, {
      method,
      credentials: "include",
      headers,
      body: body ? JSON.stringify(body) : undefined,
      signal: controller.signal,
    });
    if (!res.ok || !res.body) throw new Error(`AI request failed (${res.status})`);
    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    for (;;) {
      const { value, done } = await reader.read();
      if (done) break;
      const text = decoder.decode(value, { stream: true });
      if (text && onChunk) onChunk(text);
    }
  } finally {
    clearTimeout(timer);
  }
}
